/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import qs from 'querystring';
/**
 * GetCrmToken Input Action
 */

 export interface IToken {
    token_type: string;
    expires_in: string;
    ext_expires_in: string;
    expires_on: string;
    not_before: string;
    resource: string;
    access_token: string;
}

export class GetCrmTokenInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CRMTOKEN`;
    public getCacheObjectType = () => 'CRMTOKEN';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCrmTokenData {
    token: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetCrmTokenInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCrmTokenInput, ctx: Msdyn365.IActionContext): Promise<IGetCrmTokenData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetCrmTokenData[]>('/get/example/id/1', 'get');
    const { szfCRMDomain, szfCRMClientSecret} = ctx.requestContext.app.config;
    const data = qs.stringify({
        'resource': `${szfCRMDomain}`,
        'client_id': '1d4d5b5c-c710-472d-b8ac-104788da8da1',
        'client_secret': `${szfCRMClientSecret}`,
        'grant_type': 'client_credentials'
    });
    const response = await Msdyn365.sendRequest<IToken>("https://login.microsoftonline.com/c03a7c9b-0691-48f2-a884-93fe49a74786/oauth2/token", "post", data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'fpc=AopThjyphGZIqV8tMvZOskskZZdbAQAAAETfudgOAAAA; stsservicecookie=estsfd; x-ms-gateway-slice=estsfd'
        }
    });
    if(response && response.status===200){
        return {
            token : response.data.access_token
        };
    }else{
        return {token : ''};
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetCrmTokenData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCrmToken',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
